// extracted by mini-css-extract-plugin
module.exports = {"head":"Tabs_head__kKMOr","headItem":"Tabs_headItem__16S-o","active":"Tabs_active__3HKDE","body":"Tabs_body__MAdXy"};